// NewsPagination.js
import React from 'react';
import Pagination from '@mui/material/Pagination';
import { styled } from '@mui/material/styles';

const StyledPagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPaginationItem-root': {
    // Hide arrow buttons
    '&.MuiPaginationItem-previousNext': {
      display: 'none',
    },
  },
}));

const CustomPager = ({ pageCount, currentPage, onPageChange }) => {
    return (
        <StyledPagination
            count={pageCount}
            page={currentPage}
            onChange={onPageChange}
            showFirstButton={false}
            showLastButton={false}
            hidePrevButton={true}
            hideNextButton={true}
        />
    );
};

export default CustomPager;
